import { render } from "./CursorDefaultClick.vue?vue&type=template&id=688e5839"
import script from "./CursorDefaultClick.vue?vue&type=script&lang=js"
export * from "./CursorDefaultClick.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CursorDefaultClick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "688e5839"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('688e5839', __exports__)) {
    api.reload('688e5839', __exports__)
  }
  
  module.hot.accept("./CursorDefaultClick.vue?vue&type=template&id=688e5839", () => {
    api.rerender('688e5839', render)
  })

}


export default __exports__